import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DealershipServiceIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M14.4001 6.16008H19.4201V11.0941C19.1231 11.0324 18.8153 11 18.5 11C18.241 11 17.9871 11.0219 17.7401 11.0639V7.84008H13.7801L11.2401 14.5401H14.1026C14.0354 14.8494 14 15.1706 14 15.5C14 15.7451 14.0196 15.9856 14.0573 16.2201H8.88008L9.60008 14.1401H6.26008V20.3801H4.58008V4.08008H15.1001L14.4001 6.16008ZM6.26008 12.4601H10.2201L12.7601 5.78008H6.26008V12.4601ZM17.5339 15.3762L17.5326 15.3774L19.0288 16.8736L21.52 14.3824C22.0795 15.5609 21.8716 17.0129 20.8964 17.9882C19.9746 18.91 18.6269 19.1463 17.4868 18.697L16.0672 20.173L15.1782 21.0914L13.3857 19.299L14.27 18.3796L15.6982 16.9043C15.2549 15.7665 15.4926 14.4246 16.4114 13.5058C17.0007 12.9164 17.7642 12.6073 18.5362 12.5784C19.042 12.5595 19.5515 12.6609 20.018 12.8825L17.5291 15.3714L17.5339 15.3762Z"
      />
    </SvgIcon>
  );
});
